import React, { Component, useEffect } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import tracker, { useTrackValues } from './tracker';

// import Header from './components/Header';
import Footer from 'custom/Footer';
import Header from './components/Header';
import ProfileHeader from './components/ProfileHeader';
import PageRegistration from './components/PageRegistration';
import PageSuccess from './components/PageSuccess';
import PageAuth from './components/PageAuth';
import PageLogin from './components/PageLogin';
import PageInfoVpn from './components/PageInfoVpn';
import PageApplicantInfo from './components/PageApplicantInfo';
import PageApplicationOverview from './components/ApplicationOverview/PageApplicationOverview';
import PageMajorSubjects from './components/PageMajorSubjects';
import PageSecondarySubjects from './components/PageSecondarySubjects';
import PageRestorePassword from './components/PageRestorePassword';
import PagePhoneVerification from './components/PagePhoneVerification';
import PagePhoneVerification2 from './components/PagePhoneVerification2';
import LoginContainer from './components/LoginContainer';
import PageLanguageTestWelcome from './components/LanguageTest/PageLanguageTestWelcome'
import PageLanguageTestIntro from "./components/LanguageTest/PageLanguageTestIntro";
import PageLanguageTest from './components/LanguageTest/PageLanguageTest'
import PageSubjectTest from './components/SubjectTest/PageSubjectTest'
import PageMathTest from './components/MathTest/PageMathTest'
import PageMathTestWelcome from './components/MathTest/PageMathTestWelcome'
import PageFinanceTextTest from './components/FinanceTest/PageFinanceTextTest'
import PageFinanceTextTestWelcome from './components/FinanceTest/PageFinanceTextTestWelcome'

import PageAcademicTest from './components/AcademicTest/PageAcademicTest';
import PageEssayWelcome from './components/PageEssayWelcome';
import PageTaskCompleted from './components/PageTaskCompleted';
import PageLanguageTestFailed from './components/LanguageTest/PageLanguageTestFailed';
import PageEssayList from './components/PageEssayList'
import PageAwaitResult from './components/PageAwaitResult'
import PageCongratulations from './components/PageCongratulations';
import PageSorry from './components/PageSorry';
import PagePerfectEssay from './components/PerfectEssay/PagePerfectEssay';
import Tutorial from './components/Tutorial/PageTutorial';
import { saveQueryToStorage } from './utils/tokenStorage'
import bg from 'custom/img/bg@3x.png';
import styles from 'custom/layout.styl';
import { testFailedComplete } from './store/test/actions';

const NotFound = () => <div>Page Not Found</div>;

const AuthLayout = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={props => [
      <Header key='auth-header' />,
      <Component {...props} key='auth-component' />
    ]} />
  )
}

const ProfileLayout = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={props => [
      <ProfileHeader key='profile-header' />,
      <Component {...props} key='profile-component' />
    ]} />
  )
}

const LoginContainerRouter = () => {
  return (
    <LoginContainer>
      <Switch>
        <Redirect from="/" exact to={`/registration${window.location.search}`} />

        <AuthLayout path="/registration" component={PageRegistration} />
        <AuthLayout path="/success" component={PageSuccess} />
        <AuthLayout exact path="/login" component={PageLogin} />
        <AuthLayout path="/restore-password" component={PageRestorePassword} />

        <ProfileLayout path="/applicant-info" component={PageApplicantInfo} />
        <ProfileLayout path="/preferred-subjects" component={PageMajorSubjects} />
        <ProfileLayout path="/preferred-subjects-other" component={PageSecondarySubjects} />
        <ProfileLayout path="/vpn" component={PageInfoVpn} />
        <ProfileLayout path="/application-overview" component={PageApplicationOverview} />
        <ProfileLayout exact path="/language-test" component={PageLanguageTest} />
        <ProfileLayout path="/welcome" component={PageLanguageTestWelcome} />
        <ProfileLayout path="/language-test/intro" component={PageLanguageTestIntro} />
        <ProfileLayout path="/language-test/failed" component={PageLanguageTestFailed} />

        <ProfileLayout path="/subject-test" component={PageApplicationOverview} />
        <ProfileLayout path="/subject-test-start" component={PageSubjectTest} />

        <ProfileLayout path="/math-test" component={PageMathTestWelcome} />
        <ProfileLayout path="/math-test-start" component={PageMathTest} />
        <ProfileLayout path="/finance-test" component={PageFinanceTextTestWelcome} />
        <ProfileLayout path="/finance-test-start" component={PageFinanceTextTest} />

        <ProfileLayout path="/phone-verification" component={PagePhoneVerification} />
        <ProfileLayout path="/tutorial-start" component={Tutorial} />
        <ProfileLayout path="/tutorial" component={Tutorial} />
        <ProfileLayout path="/repeat-tutorial" component={Tutorial} />
        <ProfileLayout path="/academic-test" component={PageAcademicTest} />
        <ProfileLayout path="/essay-welcome" component={PageEssayWelcome} />

        <ProfileLayout path="/tasks/:id" component={PageEssayList} />
        <ProfileLayout path="/tasks" component={PageEssayList} />
        <ProfileLayout path="/task-completed" component={PageTaskCompleted} />

        <ProfileLayout path="/phone-verification-2" component={PagePhoneVerification2} />
        <ProfileLayout path="/result" component={PageAwaitResult} />
        <ProfileLayout path="/congratulations" component={PageCongratulations} />
        <ProfileLayout path="/sorry" component={PageSorry} />
        <ProfileLayout path="/perfect_essay" component={PagePerfectEssay} />

        <AuthLayout component={NotFound} />
      </Switch>
      <Footer />
    </LoginContainer>
  );
};

const App = () => {
  // useTrackValues('stage', 'applicant-info', {})
  const location = useLocation();

  useEffect(() => {
    saveQueryToStorage();
    tracker.metrics.trackLocation();
  }, [location])

  return (
    <div className={styles.app} style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover' }}>
      <div className={styles.main_content}>
        <Switch>
          <Route path="/login/:token" component={PageAuth} />
          <Route component={LoginContainerRouter} />
        </Switch>
      </div>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js